const SERVER_URL = "https://api.codeboard.ccstiet.com/";
// const SERVER_URL = "https://api.knowishan.fun/";
export default SERVER_URL;